import cn from "classnames";
import { UpsaleButton } from "../../../../components/UpsaleButton/UpsaleButton";
import { useRegistrationSection } from "../../../../providers/RegistrationSectionProvider/useRegistrationData";
import styles from './UpsaleFirstOffer.module.scss';
import { useNavigate } from "react-router";
import { UpsaleFirstOfferCard } from "../UpsaleFirstOfferCard/UpsaleFirstOfferCard";
import { Title } from "../../../../components/Title/Title";
import { useEffect, useRef, useState } from "react";
import { formatCentsToDollars } from "../../../../services/formatCentsToDollars";
import { addSubscriptionUpsale } from "../../../../services/addSubscriptionUpsale";
import { useUserData } from "../../../../providers/UserDataProvider/useUserData";
import { Spinner } from "../../../../components/Spinner/Spinner";
import { loadPaypalSdk, loadPaypalSdkForOrder } from "../../../../services/loadPaypalSdk";
import { getCurrencySymbol } from "../../../../services/getCurrencySymbol";
import { ampPaypalButtonClicked, ampPurchaseAdditional, ampPurchaseStatus } from "../../../../utils/AmplitudeEvents";
export const UpsaleFirstOffer = ({content:data})=>{
  const [activeIdx, setActiveIdx] = useState(0);
  const [message,setMessage] = useState(null);
  const [loading,setLoading] = useState(false);
  const [offerData, setOfferData] = useState(data.offers[0] || null);
  const {nextSlug,sessionInfo } = useRegistrationSection();
  const currency = localStorage.getItem('currency') || 'usd';
  const navigate = useNavigate();
  const [containerID, setContainerID] = useState(null)
  const { userData,setUserData } = useUserData();
  const paypalRef = useRef(null);
  const currencyCode = sessionInfo?.subscription?.currency?.toLowerCase?.() || currency || 'usd';
  const currency_code = currencyCode?.toUpperCase() || 'USD';
  const {title, offers, button,upsaleKey} = data;
  const planId = offerData?.paypalID?.[currencyCode] ?? null;
   useEffect(() => {
      let paypalButtons = null;
      if(!containerID) {
        const randomId = Math.random().toString(36).substring(2, 7);
        setContainerID(`paypal-button-${randomId}`);
        return
      }
      function renderButton() {
        if (window.paypal && planId && paypalRef.current) {
          // Очищаем контейнер
          paypalRef.current.innerHTML = "";
          paypalButtons = window.paypal.Buttons({
            style: {
              shape: 'rect',
              color: 'white',
              layout: 'vertical',
              label: 'paypal',
              tagline: false
            },
            createSubscription: function(data, actions) {
              return actions.subscription.create({
                plan_id: planId
              });
            },
            onApprove: function(data, actions) {
              handleSubmit('paypal');
              ampPurchaseStatus('UpsaleComplete');
              ampPurchaseAdditional({
                currency: currency_code,
                payment_method: 'PayPal',
                price: offerData.paypalPrice/100 || null,
                productId: planId,
                quantity: 1
              })
            },
            onClick: function (data, actions) {
              ampPurchaseStatus('UpsaleStarted');
              ampPaypalButtonClicked(offerData?.title, offerData?.newPrice,currency)
            },
            onCancel : function (data, actions) {
              ampPurchaseStatus('UpsaleDecline');
            },
            onError: function (err) {
              const errorMsg = err?.message || String(err);
              console.error('PayPal error:', errorMsg);
              setMessage(errorMsg);
            }
          });
          paypalButtons.render(`#${containerID}`)
        }
      }
      function renderOneTimeButton() {
        if (window.paypalOrder && offerData.paypalPrice && paypalRef.current) {
          // Очищаем контейнер
          paypalRef.current.innerHTML = "";
  
          paypalButtons = window.paypalOrder.Buttons({
            style: {
              shape: 'rect',
              color: 'white',
              layout: 'vertical',
              label: 'paypal',
              tagline: false
            },
            createOrder: (data, actions) => {
              return actions.order.create({
                purchase_units: [{
                  amount: { value: offerData.paypalPrice/100, currency_code: currency_code },
                  description: "Lifetime Access"
                }]
              });
            },
            onApprove: (data, actions) => {
              return actions.order.capture().then(details => {
                handleSubmit('paypal');
                ampPurchaseStatus('UpsaleComplete');
                ampPurchaseAdditional(
                  {
                    currency: currency_code,
                    payment_method: 'PayPal',
                    price: offerData.paypalPrice/100,
                    productId: offerData.paypalPrice/100,
                    quantity: 1
                  }
                )
              });
            },
            onClick: function (data, actions) {
              ampPurchaseStatus('UpsaleStarted');
              ampPaypalButtonClicked(offerData?.title, offerData?.newPrice, currency)
            },
            onCancel : function (data, actions) {
              ampPurchaseStatus('UpsaleDecline');
            },
            onError: function (err) {
              const errorMsg = err?.message || String(err);
              console.error('PayPal error:', errorMsg);
              setMessage(errorMsg);
            }
          });
          paypalButtons.render(`#${containerID}`)
        }
      }
  
      if(offerData.type==='subscription'){
        loadPaypalSdk(renderButton);
      }else{
        loadPaypalSdkForOrder(currency_code, 
          renderOneTimeButton
        )
      }
  
      
  
      return () => {
        if (paypalButtons) paypalButtons.close();
        if (paypalRef.current) paypalRef.current.innerHTML = "";
      };
    }, [offerData,containerID])
    ;
  const handleSubmit = async (type='stripe')=>{
    const {priceID,discountID,title,period,newPrice,oldPrice,course_id} = offerData;
    const {subscription, customer}=sessionInfo;
    setLoading(true);
    const {error } = await addSubscriptionUpsale({
      planID : priceID ||null,
      customerID : customer.id || null,
      discountID : discountID || null,
      title : title || null,
      period : period || null,
      discounted : newPrice / 100,
      subscription : oldPrice / 100,
      currency: subscription.currency || currency || 'usd',
      userEmail: customer.email
    },type);
    setLoading(false);
    if(error){
      console.error(error)
      setMessage(error)
    }else {
      setUserData({
        ...userData,
        upsale:{
          ...userData.upsale,
          [upsaleKey]:"paid"
        },
        upsaleIDs: [
          ...(userData.upsaleIDs || []),
          ...(Array.isArray(course_id) ? course_id : [course_id])
        ]
      }
      )
      navigate(nextSlug);
    }
  }
  if(!data) return;
  const currencySymbol = getCurrencySymbol(currencyCode);
  const old = formatCentsToDollars(offerData.oldPrice);
  const next = formatCentsToDollars(offerData.newPrice);
  const footerText = `By clicking ${button || 'ADD TO MY PLAN'}, I agree that in addition to my plan subscription, my account will be charged ${currencySymbol + next.integer + '.'+ next.fraction} for the add-on I have selected and it will automatically renew each ${offerData.period || '1-month'} until I cancel, Hapday will automatically charge my payment method ${currencySymbol + old.integer + '.'+ old.fraction} every ${offerData.period || '1-month'}. I can cancel my subscription by contacting  to avoid being charged for the next billing cycle.`;

  return(
    <>
    {loading && <Spinner state={'opacity'} />}
    <div className={styles.wrapper}>
      {title && <Title className={styles.title} dangerouslySetInnerHTML={{ __html:title }}/>}
      <div className={styles.offers}>
        {offers.map((offer, idx)=>{
          return(
            <UpsaleFirstOfferCard
              key={idx}
              content={offer}
              currency={currencySymbol}
              status={idx === activeIdx ? "active" : ""}
              onClick={() => {
                setOfferData(offer);
                setActiveIdx(idx);
              }}
            />
          )
        })}
      </div>
      {message && <div className={styles.message}>{message}</div>}
      {offerData.type === 'subscription' && (
        <div className={styles.text}>{footerText}</div>
      )}
      {sessionInfo?.subscription?.type ==='paypal' ? <div className={styles.paypal}>
        <div id={containerID} ref={paypalRef}></div>
        </div>:
      <UpsaleButton
        onClick={handleSubmit}
        className={cn(styles.button)}
      >
        {button || "Add to my plan"}
      </UpsaleButton>
        }
    </div>
    </>

  )
}